import React, {useState,useEffect} from 'react'

export default function About() {

   const state = { 'page_id': 1, 'user_id': 5 }
	const title = ''
	const url = 'index.html'

   const getWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

   const [width, setWidth] = useState(getWidth());

   useEffect(() => {
      setTimeout(function () {
         document.querySelector(".loader-wrapper").style = "display: none";
      }, 2000);

      // timeoutId for debounce mechanism
      let timeoutId = null;
      const resizeListener = () => {
        // prevent execution of previous setTimeout
        clearTimeout(timeoutId);
        // change width from the state object after 150 milliseconds
        timeoutId = setTimeout(() => setWidth(getWidth()), 150);
      };
      // set resize listener
      window.addEventListener('resize', resizeListener);
    
      // clean up function
      return () => {
        // remove resize listener
        window.removeEventListener('resize', resizeListener);
      }
    }, [])

    // width == 1199
    // need to center the guys
    const aboutTextStyle = {
       display: 'flex',
       justifyContent: width < 768 ? 'center':'flex-start',
       alignItems: 'center',
       height: '48px',
       position: 'relative',
       left: width < 768 ? '-36px' : '0'
      }


   
   // Media max with 768! For moving everything to the center.
   const centerStyle = width > 768 ? {} : {
     display:'flex',
     flexDirection: 'column',
     justifyContent:'center',
     alignItems: 'center',
     textAlign: 'center',
     width:'100%',
     padding: 0,
     margin: 0,
   }

   const aboutContainerStyle = width > 768 ? {} : {...centerStyle, padding: '4rem 0'}

   const descriptionStyle  = width > 768 ? {} : {...centerStyle, padding: '0 2rem'}

   const spacer = <span style={{width: '100px'}}></span>
   const verticalSpacer = width > 768 ? <div style={{height: '0px'}} /> : <div style={{height: '40px'}} />

   return (
      <section id="about" className="about" style={aboutContainerStyle}>
         <div className="about-decor">
            <div className="about-circle1"><img src="assets/images/team1.png" alt="team1" /></div>
            <div className="about-circle2"><img src="assets/images/main-banner1.png" alt="banner1" /></div>
         </div>
         <div className="container" style={centerStyle}>
            <div className="row " style={centerStyle}>
               <div className={width<768? "" : "col-5"} style={centerStyle}>
                  <div className="about-contain" style={centerStyle}>
                     <div style={centerStyle}>
                        <h2 className="title">about<span style={{color:'transparent', fontSize: '10px'}}>l</span><span className='dropspin-thick'>Dropspin</span></h2>
                        
                        <p className="caption-about" style={descriptionStyle}>DropSpin is the world's only score-synced metronome System.
                        Just upload your score, and you're ready to rehearse.
                        </p>
                        {verticalSpacer}

                        {/* DropSpin is the lightweight, high-performance rehearsal tool you've always wanted.
                        Never spend money on 9V's, or program a metronome AGAIN. */}
                        
                        {/* DropSpin is the lightweight, high-performance rehearsal tool you've always wanted.
                        Just connect your score, and you're ready to rehearse. */}
                        <div className="row sm-mb" >

                           <ul className="about-style" >
                              <li className="abt-hover">
                                 {width < 768 ? <div></div> :

                                 <div className="about-icon">
                                    <div className="icon-hover">
                                       <img src="assets/images/accent_icon.png" alt="easy-to-use" style={{width: '20px'}}/>
                                    </div>
                                 </div>
                                 }
                                 
                                 <div className="about-text" style={aboutTextStyle}>
                                    <h3>Custom Count-Ins</h3>
                                 </div>
                              </li>
                              <li className="abt-hover">
                              {width < 768 ? <div></div> :

                                 <div className="about-icon">
                                    <div className="icon-hover">
                                    <img src="assets/images/quarter_icon.png" alt="easy-to-use" style={{width: '20px'}}/>
                                    </div>
                                 </div>
                                 }
                                 <div className="about-text"style={aboutTextStyle}>
                                    <h3>Loopable Segments</h3>
                                 </div>
                              </li>
                              
                              <li className="abt-hover">
                              {width < 768 ? <div></div> :

                                 <div className="about-icon">
                                    <div className="icon-hover">
                                    <img src="assets/images/eighth_icon.png" alt="easy-to-use" style={{width: '20px'}}/>
                                    </div>
                                 </div>
                                 }
                                 <div className="about-text"style={aboutTextStyle}>
                                    <h3>"Last Time" Auto-Stop</h3>
                                 </div>
                              </li>
                              <li className="abt-hover">
                              {width < 768 ? <div></div> :

                                 <div className="about-icon">
                                    <div className="icon-hover">
                                    <img src="assets/images/triplet_icon.png" alt="easy-to-use" style={{width: '20px'}}/>
                                    </div>
                                 </div>
                                 }
                                 <div className="about-text"style={aboutTextStyle}>
                                    <h3>Halftime and other custom behaviors</h3>
                                 </div>
                              </li>
                              <li className="abt-hover">
                              {width < 768 ? <div></div> :

                                 <div className="about-icon">
                                    <div className="icon-hover">
                                    <img src="assets/images/sixteenth_icon.png" alt="easy-to-use" style={{width: '20px'}}/>
                                    </div>
                                 </div>
                                 }
                                 <div className="about-text"style={aboutTextStyle}>
                                    <h3>Rehearse from 50%-150% speed.</h3>
                                 </div>
                              </li>
                           </ul>




                        </div>
                        <div className="top-margin">
                           <button type="button" className="btn btn-custom theme-color theme-color"
                           onClick= {()=> {
                              window.history.pushState(state, title, url)
                              window.location.replace("https://app.dropspin.io/")
							      }}
                     >Try for Free</button>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="col-md-7 d-medium-none">
                  <div className="about-right">
                     <div className="about-phone">
                        <img src="assets/images/aboutus.png" className="img-fluid" alt="aboutus" />
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
}



// WEBPACK FOOTER //
// ./src/components/about.js